import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type OfferButtonProps = {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  small?: boolean;
};
export function OfferButton({
  children,
  href,
  onClick,
  className = '',
  small = false
}: OfferButtonProps) {
  const sharedClassName = `group relative inline-flex items-center justify-center gap-3 rounded-full bg-gradient-to-b from-[#e0563d] to-[#c84730] font-extrabold uppercase tracking-[0.1em] text-white shadow-[0_8px_20px_rgba(200,71,48,0.4),inset_0_1px_0_rgba(255,255,255,0.2)] border-b-4 border-[#9c3421] transition-all hover:brightness-110 hover:-translate-y-0.5 hover:shadow-[0_12px_25px_rgba(200,71,48,0.5),inset_0_1px_0_rgba(255,255,255,0.2)] active:border-b-0 active:translate-y-1 focus:outline-none focus:ring-4 focus:ring-[#c84730]/40 animate-[pulse_3s_ease-in-out_infinite] ${small ? 'px-5 py-3 text-[10px]' : 'w-full px-8 py-5 text-sm sm:w-auto sm:px-10'} ${className}`;
  if (href) {
    return <a className={sharedClassName} href={href} onClick={onClick} data-id="element-8">
        <span data-id="element-9">{children}</span>
        <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-10" />
      </a>;
  }
  return <button className={sharedClassName} type="button" onClick={onClick} data-id="element-11">
      <span data-id="element-12">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-13" />
    </button>;
}